import { Typography } from "antd";
import { ReactNode } from "react";

interface IProps {
    title: string;
    subTitle: string;
    children: ReactNode;
}

export default function ConfigRow({
    title,
    subTitle,
    children,
}: IProps) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 8,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Typography.Text strong>{title}</Typography.Text>
                <Typography.Text type="secondary">{subTitle}</Typography.Text>
            </div>

            {children}
        </div>
    )
}
